export default __webpack_public_path__ + "static/media/openinterest.4b5b6bad.svg";